
const Definition = {

    plan_level: 1,
    id: "launchpad",
    name: "Launchpad",
    path: "member/launchpad/components/Landing",
    preview_image: "https://img.freepik.com/free-vector/gradient-rocket-background_23-2148146034.jpg?semt=ais_hybrid&w=740&q=80",
    colors: {
        red: "#EF4444",
        muted: "#9f9fb4",
        green: "#22C55E",
        accent: "#4F6EF7",
        text_color: "#E8E8F0",
        main_color1: "#0A0A0F",
        main_color2: "#111118",
        main_color3: "#1A1A24",
        header_bg: "#0a0a0fed",
        main_color4: "#22222E",
        primary_color: "#C9A84C",
        primary_color_light: "#E8C96A"
    }

};

export default Definition;
